export const icons = {
  activity: (
    <svg width='24' height='25' viewBox='0 0 24 24' fill='none'>
      <path
        d='M3 11.69h4.345L9.828 3l4.344 18 2.483-9.31H21'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  'add-circle-outline': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M256 176v160m80-80H176'
      />
    </svg>
  ),
  'add-user': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        d='M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M88 176v112m56-56H32'
      />
    </svg>
  ),
  add: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M256 176v160m80-80H176'
      />
    </svg>
  ),
  affinity: (
    <svg height='24' width='24' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M17 12c0 .55-.45 1-1 1-3.31 0-6 2.69-6 6 0 .55-.45 1-1 1s-1-.45-1-1c0-3.31-2.69-6-6-6-.55 0-1-.45-1-1s.45-1 1-1c3.31 0 6-2.69 6-6 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6 .55 0 1 .45 1 1Zm5.5-7.5c-1.65 0-3-1.35-3-3 0-.27-.23-.5-.5-.5s-.5.23-.5.5c0 1.65-1.35 3-3 3-.27 0-.5.23-.5.5s.23.5.5.5c1.65 0 3 1.35 3 3 0 .27.23.5.5.5s.5-.23.5-.5c0-1.65 1.35-3 3-3 .27 0 .5-.23.5-.5s-.23-.5-.5-.5Zm0 14c-1.65 0-3-1.35-3-3 0-.27-.23-.5-.5-.5s-.5.23-.5.5c0 1.65-1.35 3-3 3-.27 0-.5.23-.5.5s.23.5.5.5c1.65 0 3 1.35 3 3 0 .27.23.5.5.5s.5-.23.5-.5c0-1.65 1.35-3 3-3 .27 0 .5-.23.5-.5s-.23-.5-.5-.5Z'
      />
    </svg>
  ),
  'aircheck-pending': (
    <svg width='24' height='24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.06 22.584c.246.079.503.119.763.119.254-.006.506-.049.746-.128a12.577 12.577 0 0 0 6.026-3.744 11.84 11.84 0 0 0 2.897-6.393l.095-.16-.043-.255.018-.158c.034-.286.067-.575.067-.856a19.943 19.943 0 0 0-.425-4.995 1.963 1.963 0 0 0-.68-1.177 2.08 2.08 0 0 0-1.3-.481 9.262 9.262 0 0 1-2.243-.397 7.296 7.296 0 0 1-3.49-2.11 2.806 2.806 0 0 0-.69-.584l-.157-.092h-.052A1.692 1.692 0 0 0 11.837 1a1.872 1.872 0 0 0-.783.178h-.038l-.14.087a2.79 2.79 0 0 0-.709.598A6.188 6.188 0 0 1 8.69 3.087 9.355 9.355 0 0 1 4.443 4.36a2.087 2.087 0 0 0-1.317.49 1.96 1.96 0 0 0-.675 1.2c-.136.662-.24 1.333-.316 2-.229 1.74-.167 3.505.184 5.224 1.024 4.685 3.964 7.817 8.74 9.31ZM8.943 10.009c.123-1.521 1.223-2.461 2.87-2.461.376-.02.751.035 1.104.163.351.127.672.326.942.583.267.253.478.56.617.9.139.338.203.701.188 1.066 0 1.374-.84 2.073-1.45 2.58-.41.333-.64.543-.64.79v.265a.776.776 0 0 1-.245.547.827.827 0 0 1-.573.22.82.82 0 0 1-.764-.476.769.769 0 0 1-.066-.305v-.274c0-.908.608-1.429 1.137-1.868.53-.438.944-.789.944-1.493a1.05 1.05 0 0 0-.31-.859 1.13 1.13 0 0 0-.884-.31 1.082 1.082 0 0 0-.87.252 1.047 1.047 0 0 0-.27.366c-.062.139-.092.29-.087.442a.777.777 0 0 1-.265.51.826.826 0 0 1-.55.202.852.852 0 0 1-.606-.246.736.736 0 0 1-.222-.594Zm2.227 5.517a.96.96 0 0 1 .652-.275.96.96 0 0 1 .668.267.904.904 0 0 1 .276.646.9.9 0 0 1-.276.646.96.96 0 0 1-.668.267.957.957 0 0 1-.652-.275.9.9 0 0 1-.197-.984.898.898 0 0 1 .197-.292Z'
        fill='currentColor'
      />
    </svg>
  ),
  'aircheck-success': (
    <svg width='24' height='24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.833 22.452c.313.1.639.152.967.152.314.014.628-.018.932-.095a12.275 12.275 0 0 0 5.89-3.693c1.841-2.085 2.807-4.604 2.967-7.698a19.493 19.493 0 0 0-.4-4.788 2.632 2.632 0 0 0-.9-1.552 2.74 2.74 0 0 0-1.705-.64 7.485 7.485 0 0 1-1.826-.33 5.793 5.793 0 0 1-2.78-1.68 3.61 3.61 0 0 0-.83-.708l-.363-.217-.096-.038A2.402 2.402 0 0 0 11.814 1a2.201 2.201 0 0 0-.966.203H10.8l-.32.188a3.47 3.47 0 0 0-.855.727 4.66 4.66 0 0 1-1.135.943 7.522 7.522 0 0 1-3.465 1.042 2.777 2.777 0 0 0-1.706.665 2.657 2.657 0 0 0-.893 1.567 22.113 22.113 0 0 0-.3 1.887 15.662 15.662 0 0 0 .18 5.06c1 4.614 3.87 7.704 8.527 9.17Zm4.903-12.93a.852.852 0 0 1 .19.45.945.945 0 0 1-.304.75l-1.933 2-1.073 1.103-.913.944a1.014 1.014 0 0 1-.71.343 1.022 1.022 0 0 1-.706-.32l-.778-.75-1.493-1.415a.895.895 0 0 1-.314-.778.842.842 0 0 1 .185-.452.875.875 0 0 1 .41-.279.915.915 0 0 1 .966.226l.386.373.167.16c.229.218.464.443.693.67.1.097.197.197.296.297l.15.151L14.335 9.5a.905.905 0 0 1 .99-.255c.16.052.303.148.41.277Z'
        fill='currentColor'
      />
    </svg>
  ),
  alert: (
    <svg width='24' height='24' viewBox='0 0 512 512'>
      <path
        d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        fill='currentColor'
        d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'
      />
    </svg>
  ),
  android: (
    <svg viewBox='0 0 553.048 553.048' xmlSpace='preserve'>
      <path d='M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847 375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zM476.275 179.141c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z' />
    </svg>
  ),
  apple: (
    <svg viewBox='0 0 170 170'>
      <path d='M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 0 1-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24z' />
    </svg>
  ),
  'arrow-back': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='48'
        d='M244 400L100 256l144-144M120 256h292'
      />
    </svg>
  ),
  'arrow-right': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z'
        fill='currentColor'
      />
    </svg>
  ),
  'arrow-up': (
    <svg width='24' height='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='48'
        d='M112 244l144-144 144 144M256 120v292'
      />
    </svg>
  ),
  artist: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='24'
      height='24'>
      <path
        fill='currentColor'
        d='M13.363 10.474l-.521.625a2.499 2.499 0 00.67 3.766l.285.164a5.998 5.998 0 011.288-1.565l-.573-.33a.5.5 0 01-.134-.754l.52-.624a7.372 7.372 0 001.837-4.355 7.221 7.221 0 00-.29-2.489 5.644 5.644 0 00-3.116-3.424A5.771 5.771 0 006.753 2.87a5.7 5.7 0 00-1.19 2.047 7.22 7.22 0 00-.29 2.49 7.373 7.373 0 001.838 4.355l.518.622a.5.5 0 01-.134.753L3.5 15.444a5 5 0 00-2.5 4.33v2.231h13.54a5.981 5.981 0 01-1.19-2H3v-.23a3 3 0 011.5-2.6l3.995-2.308a2.5 2.5 0 00.67-3.766l-.521-.625a5.146 5.146 0 01-1.188-4.918 3.71 3.71 0 01.769-1.334 3.769 3.769 0 015.556 0c.346.386.608.84.768 1.334.157.562.22 1.146.187 1.728a5.379 5.379 0 01-1.373 3.188zm7.641-1.173a1 1 0 00-1 1v4.666h-1a3 3 0 103 3v-7.666a.999.999 0 00-1.003-1h.003zm-1 8.666a1 1 0 11-1-1h1v1z'
      />
    </svg>
  ),
  bin: (
    <svg width='20' height='20' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M15 4V3H9v1H4v2h1v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6h1V4h-5zm2 15H7V6h10v13z'
      />
      <path fill='currentColor' d='M9 8h2v9H9zm4 0h2v9h-2z' />
    </svg>
  ),
  'bookmarks-outline': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M128 80V64a48.14 48.14 0 0148-48h224a48.14 48.14 0 0148 48v368l-80-64'
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='40'
      />
      <path
        d='M320 96H112a48.14 48.14 0 00-48 48v352l152-128 152 128V144a48.14 48.14 0 00-48-48z'
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='40'
      />
    </svg>
  ),
  'checkbox-blank-circle': (
    <svg viewBox='0 0 24 24' width='24' height='24' fill='none'>
      <path
        d='M2 12C2 6.487 6.487 2 12 2s10 4.487 10 10-4.487 10-10 10S2 17.513 2 12z'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  ),
  'checkbox-marked-circle': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29-134.4 160a16 16 0 0 1-12 5.71h-.27a16 16 0 0 1-11.89-5.3l-57.6-64a16 16 0 1 1 23.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0 1 24.5 20.58z'
        fill='currentColor'
      />
    </svg>
  ),
  'checkmark-circle-outline': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M352 176L217.6 336 160 272'
      />
    </svg>
  ),
  checkmark: (
    <svg viewBox='0 0 512 512' width='24' height='24'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='40'
        d='M416 128L192 384l-96-96'
      />
    </svg>
  ),
  'chevron-back-outline': (
    <svg height='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='48'
        d='M328 112L184 256l144 144'
      />
    </svg>
  ),
  'chevron-down': (
    <svg viewBox='0 0 24 24' width='24' height='24' fill='none'>
      <path
        fill='currentColor'
        d='M4.47 8.97a.75.75 0 0 1 1.06 0L12 15.44l6.47-6.47a.749.749 0 1 1 1.06 1.06L12 17.56l-7.53-7.53a.75.75 0 0 1 0-1.06Z'
      />
    </svg>
  ),
  'chevron-down-small': (
    <svg width='24' height='24' viewBox='0 0 24 24'>
      <path
        d='M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  ),
  'chevron-expand': (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      stroke='currentColor'
      viewBox='0 0 16 16'>
      <path
        strokeWidth='0.5'
        d='M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z'
      />
    </svg>
  ),
  'chevron-contract': (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      stroke='currentColor'
      viewBox='0 0 16 16'>
      <path
        strokeWidth='0.5'
        d='M3.646 13.854a.5.5 0 0 0 .708 0L8 10.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-11.708a.5.5 0 0 1 .708 0L8 5.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708z'
      />
    </svg>
  ),
  clearbit: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 72 72'>
      <defs>
        <linearGradient id='clearbitA' x1='0%' x2='100%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='currentColor' stopOpacity='.753' />
          <stop offset='100%' stopColor='currentColor' stopOpacity='.501' />
        </linearGradient>
        <linearGradient id='clearbitB' x1='37.5%' x2='62.5%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='currentColor' stopOpacity='.946' />
          <stop offset='100%' stopColor='currentColor' stopOpacity='.903' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='currentColor'
          d='M72 36v16.77l-.004.868c-.06 6.035-.75 8.353-2 10.688a13.63 13.63 0 0 1-5.67 5.67l-.326.171C61.658 71.364 59.16 72 52.77 72H36V36h36Z'
          opacity='.204'
        />
        <path
          fill='url(#clearbitA)'
          d='M64.326 2.003a13.63 13.63 0 0 1 5.67 5.67l.171.327C71.364 10.342 72 12.84 72 19.23V36H36V0h16.77c6.687 0 9.112.696 11.556 2.003Z'
        />
        <path
          fill='url(#clearbitB)'
          d='M36 0v72H19.23l-.868-.004c-6.035-.06-8.353-.75-10.688-2a13.63 13.63 0 0 1-5.67-5.67L1.832 64C.636 61.658 0 59.16 0 52.77V19.23c0-6.687.696-9.112 2.003-11.556a13.63 13.63 0 0 1 5.67-5.67L8 1.832C10.342.636 12.84 0 19.23 0H36Z'
        />
      </g>
    </svg>
  ),
  'close-circle-outline': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M320 320L192 192m0 128l128-128'
      />
    </svg>
  ),
  'close-circle': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path d='M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z' />
    </svg>
  ),
  close: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='currentColor'
        d='M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z'
      />
    </svg>
  ),
  cloud: (
    <svg fill='none' height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 18.11-16.53 42.22-28.25 69.18-33.87a16 16 0 0011.37-9.15 156.24 156.24 0 0142.05-56C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c24.73 23.81 41.5 55.28 49.18 92a16 16 0 0012.12 12.39C470 237.42 512 270.43 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z'
        fill='currentColor'
      />
    </svg>
  ),
  'code-outline': (
    <svg width='24' height='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='34'
        d='M160 368L32 256l128-112M352 368l128-112-128-112'
      />
    </svg>
  ),
  'color-pallete': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <circle fill='currentColor' cx='144' cy='208' r='32' />
      <circle fill='currentColor' cx='152' cy='311' r='32' />
      <circle fill='currentColor' cx='224' cy='144' r='32' />
      <circle fill='currentColor' cx='256' cy='367' r='48' />
      <circle fill='currentColor' cx='328' cy='144' r='32' />
    </svg>
  ),
  columns: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <rect x='11' y='3' width='2' height='18' rx='1' fill='currentColor' />
      <rect
        x='4'
        y='4'
        width='16'
        height='16'
        rx='3'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  ),
  contract: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432'
      />
    </svg>
  ),
  copy: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <rect
        x='128'
        y='128'
        width='336'
        height='336'
        rx='57'
        ry='57'
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        d='M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
    </svg>
  ),
  'date-alternative': (
    <svg fill='currentColor' height='24' width='24' viewBox='0 0 24 24'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 5H9V4a1 1 0 00-2 0v1H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2h-2V4a1 1 0 10-2 0v1zM6 7a1 1 0 00-1 1v2h14V8a1 1 0 00-1-1h-1a1 1 0 11-2 0H9a1 1 0 01-2 0H6zm13 5H5v6a1 1 0 001 1h12a1 1 0 001-1v-6z'
      />
    </svg>
  ),
  date: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <rect
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='32'
        x='48'
        y='80'
        width='416'
        height='384'
        rx='48'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='32'
        strokeLinecap='round'
        d='M128 48v32m256-32v32m80 80H48'
      />
    </svg>
  ),
  'discover-outline': (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M10 1.613a1 1 0 0 1 .995.906c.123 1.29.685 3.314 1.963 5.079 1.257 1.734 3.197 3.21 6.147 3.52a1 1 0 0 1 0 1.99c-2.95.31-4.89 1.787-6.148 3.521-1.277 1.764-1.84 3.79-1.962 5.078a1 1 0 0 1-1.99 0c-.123-1.288-.685-3.315-1.962-5.078-1.258-1.734-3.198-3.21-6.148-3.522a1 1 0 0 1 0-1.989c2.95-.31 4.89-1.787 6.148-3.52 1.277-1.764 1.84-3.79 1.961-5.079A1 1 0 0 1 10 1.613Zm-5.298 10.5c1.708.818 3.004 2.024 3.96 3.344.53.734.979 1.523 1.338 2.354.343-.788.784-1.59 1.338-2.354.956-1.32 2.252-2.527 3.96-3.344-1.708-.816-3.005-2.024-3.96-3.342A12.58 12.58 0 0 1 10 6.413c-.36.832-.808 1.622-1.338 2.357-.956 1.318-2.252 2.525-3.96 3.342ZM16.98 3.917c1.602-.508 2.434-1.776 2.798-2.83.04-.115.406-.115.446 0 .364 1.053 1.196 2.321 2.798 2.83.115.035.115.36 0 .395-1.602.508-2.434 1.776-2.798 2.83-.04.114-.406.114-.446 0-.364-1.054-1.196-2.322-2.798-2.83-.115-.035-.115-.36 0-.395ZM21.5 19.71a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z'
      />
    </svg>
  ),
  discover: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M16.985 3.916c1.602-.508 2.434-1.776 2.798-2.83.04-.115.406-.115.446 0 .364 1.053 1.196 2.321 2.798 2.83.115.035.115.36 0 .395-1.602.508-2.434 1.776-2.798 2.83-.04.114-.406.114-.446 0-.364-1.054-1.196-2.322-2.798-2.83-.115-.035-.115-.36 0-.395Zm-5.984-1.397a1 1 0 0 0-1.99 0c-.124 1.29-.685 3.314-1.963 5.079C5.79 9.332 3.85 10.808.9 11.117a1 1 0 0 0 0 1.99c2.95.31 4.89 1.787 6.148 3.521 1.277 1.763 1.84 3.79 1.961 5.078a1 1 0 0 0 1.992 0c.122-1.29.684-3.315 1.961-5.078 1.258-1.735 3.198-3.21 6.148-3.522a1 1 0 0 0 0-1.989c-2.95-.31-4.89-1.787-6.148-3.52-1.277-1.764-1.839-3.79-1.96-5.079Zm9.005 18.691a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
    </svg>
  ),
  dot: (
    <svg height='6' width='6' viewBox='0 0 6 6'>
      <circle cx='3' cy='3' r='3' fill='currentColor' />
    </svg>
  ),
  download: (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 2C9.8181 2 8.64778 2.23279 7.55585 2.68508C6.46392 3.13738 5.47177 3.80031 4.63604 4.63604C3.80031 5.47177 3.13738 6.46392 2.68508 7.55585C2.23279 8.64778 2 9.8181 2 11C2 12.1819 2.23279 13.3522 2.68508 14.4442C3.13738 15.5361 3.80031 16.5282 4.63604 17.364C5.47177 18.1997 6.46392 18.8626 7.55585 19.3149C8.64778 19.7672 9.8181 20 11 20C13.3869 20 15.6761 19.0518 17.364 17.364C19.0518 15.6761 20 13.3869 20 11C20 8.61305 19.0518 6.32387 17.364 4.63604C15.6761 2.94821 13.3869 2 11 2ZM0 11C0 4.925 4.925 0 11 0C17.075 0 22 4.925 22 11C22 17.075 17.075 22 11 22C4.925 22 0 17.075 0 11Z'
        fill='currentColor'
      />
      <path
        d='M11 5.05C11.2652 5.05 11.5196 5.15536 11.7071 5.34289C11.8946 5.53043 12 5.78478 12 6.05V13.536L13.793 11.743C13.8852 11.6475 13.9956 11.5713 14.1176 11.5189C14.2396 11.4665 14.3708 11.4389 14.5036 11.4377C14.6364 11.4366 14.7681 11.4619 14.891 11.5122C15.0139 11.5625 15.1255 11.6367 15.2194 11.7306C15.3133 11.8245 15.3875 11.9361 15.4378 12.059C15.4881 12.1819 15.5134 12.3136 15.5123 12.4464C15.5111 12.5792 15.4835 12.7104 15.4311 12.8324C15.3787 12.9544 15.3025 13.0648 15.207 13.157L11 17.364L6.793 13.157C6.69749 13.0648 6.62131 12.9544 6.5689 12.8324C6.51649 12.7104 6.4889 12.5792 6.48775 12.4464C6.4866 12.3136 6.5119 12.1819 6.56218 12.059C6.61246 11.9361 6.68671 11.8245 6.7806 11.7306C6.8745 11.6367 6.98615 11.5625 7.10905 11.5122C7.23194 11.4619 7.36362 11.4366 7.4964 11.4377C7.62918 11.4389 7.7604 11.4665 7.8824 11.5189C8.00441 11.5713 8.11475 11.6475 8.207 11.743L10 13.536V6.05C10 5.78478 10.1054 5.53043 10.2929 5.34289C10.4804 5.15536 10.7348 5.05 11 5.05Z'
        fill='currentColor'
      />
    </svg>
  ),
  expand: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304'
      />
    </svg>
  ),
  experian: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M13.793 7.24h-2.035a1.092 1.092 0 0 1-1.102-1.103V4.102A1.103 1.103 0 0 1 11.758 3h2.036a1.103 1.103 0 0 1 1.1 1.102v2.035a1.094 1.094 0 0 1-1.1 1.102h-.001ZM8.51 11.812H6.233A1.23 1.23 0 0 1 5 10.582V8.285a1.244 1.244 0 0 1 1.233-1.233h2.296a1.23 1.23 0 0 1 1.232 1.233v2.297a1.235 1.235 0 0 1-1.253 1.231h.003Zm-.208 4.762h-1.4a.749.749 0 0 1-.747-.744v-1.403a.75.75 0 0 1 .747-.747h1.4a.749.749 0 0 1 .747.747v1.403a.748.748 0 0 1-.747.748v-.004ZM12.055 21h-1.66a.9.9 0 0 1-.897-.897v-1.66a.896.896 0 0 1 .896-.897h1.661a.895.895 0 0 1 .9.896v1.661a.885.885 0 0 1-.897.897h-.003Zm6.069-12.92h-1.14a.62.62 0 0 1-.612-.616v-1.14a.623.623 0 0 1 .616-.616h1.14a.622.622 0 0 1 .615.616v1.14c.019.336-.261.615-.616.615h-.003Zm-.317 4.63c-.018-1.68-1.513-3.099-3.286-3.099a3.296 3.296 0 0 0 0 6.59 3.232 3.232 0 0 0 2.296-.933.564.564 0 0 0 .187-.41.553.553 0 0 0-.542-.542.58.58 0 0 0-.43.224c-.372.392-.914.58-1.492.58-1.102 0-2-.748-2.185-1.793h4.985a.066.066 0 0 0 .057-.02.658.658 0 0 0 .41-.596v-.001Zm-3.286-2.017a2.173 2.173 0 0 1 2.091 1.533h-4.201a2.18 2.18 0 0 1 2.11-1.533Zm3.382 5.514a.072.072 0 0 1-.055-.02.074.074 0 0 1-.02-.056v-.74h-.166a.074.074 0 0 1-.058-.02.075.075 0 0 1 .056-.131h.485a.073.073 0 0 1 .058.019.075.075 0 0 1 .018.087.075.075 0 0 1-.075.046h-.167v.74a.074.074 0 0 1-.022.055.072.072 0 0 1-.054.02Zm.861 0c-.045 0-.06-.03-.075-.06l-.21-.606v.59a.076.076 0 0 1-.06.081.075.075 0 0 1-.046-.005.075.075 0 0 1-.045-.075v-.787a.103.103 0 0 1 .106-.106.114.114 0 0 1 .106.075l.213.62.21-.62a.115.115 0 0 1 .148-.068.102.102 0 0 1 .064.099v.786a.078.078 0 0 1-.019.058.074.074 0 0 1-.086.018.075.075 0 0 1-.046-.075v-.591c-.03.09-.075.242-.12.363-.076.243-.092.243-.092.243.016.045-.015.06-.046.06h-.002Z'
        fill='currentColor'
      />
    </svg>
  ),
  external: (
    <svg height='24' width='24' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M19 6.41 8.7 16.71a1 1 0 1 1-1.4-1.42L17.58 5H14a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V6.41zM17 14a1 1 0 0 1 2 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h5a1 1 0 0 1 0 2H5v12h12v-5z'
      />
    </svg>
  ),
  eye: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <circle cx='256' cy='256' r='64' fill='currentColor' />
      <path
        d='M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 0 0-.1-34.76zM256 352a96 96 0 1 1 96-96 96.11 96.11 0 0 1-96 96z'
        fill='currentColor'
      />
    </svg>
  ),
  filter: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='currentColor'
        d='M472 168H40a24 24 0 010-48h432a24 24 0 010 48zm-80 112H120a24 24 0 010-48h272a24 24 0 010 48zm-96 112h-80a24 24 0 010-48h80a24 24 0 010 48z'
      />
    </svg>
  ),
  google: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      width='24'
      viewBox='0 0 128 128'>
      <g clipRule='evenodd'>
        <path fill='none' d='M0 0h128v128H0z' />
        <path
          fill='#FBBC05'
          fillRule='evenodd'
          d='M27.585 64c0-4.157.69-8.143 1.923-11.881L7.938 35.648C3.734 44.183 1.366 53.801 1.366 64c0 10.191 2.366 19.802 6.563 28.332l21.558-16.503A37.86 37.86 0 0 1 27.585 64'
        />
        <path
          fill='#EA4335'
          fillRule='evenodd'
          d='M65.457 26.182c9.031 0 17.188 3.2 23.597 8.436L107.698 16C96.337 6.109 81.771 0 65.457 0 40.129 0 18.361 14.484 7.938 35.648l21.569 16.471a37.77 37.77 0 0 1 35.95-25.937'
        />
        <path
          fill='#34A853'
          fillRule='evenodd'
          d='M65.457 101.818a37.77 37.77 0 0 1-35.949-25.937L7.938 92.349C18.361 113.516 40.129 128 65.457 128c15.632 0 30.557-5.551 41.758-15.951L86.741 96.221c-5.777 3.639-13.052 5.597-21.284 5.597'
        />
        <path
          fill='#4285F4'
          fillRule='evenodd'
          d='M126.634 64c0-3.782-.583-7.855-1.457-11.636h-59.72v24.727h34.376c-1.719 8.431-6.397 14.912-13.092 19.13l20.474 15.828c11.766-10.92 19.419-27.188 19.419-48.049'
        />
      </g>
    </svg>
  ),
  group: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M6.112 13.497c-.014-.295-.01-.59.013-.885h-3.94c.216-.57.621-1.05 1.148-1.357l1.4-.807a2.337 2.337 0 00.624-3.521 2.752 2.752 0 01-.654-2.63A1.85 1.85 0 015.728 3.16a1.915 1.915 0 012.182.458 1.9 1.9 0 01.389.677 2.762 2.762 0 01-.657 2.633 2.326 2.326 0 00-.506 1.9c.034.188.092.37.173.544a4 4 0 01.33-.4 5.922 5.922 0 011.978-1.418c.016-.007.033-.011.05-.018a4.687 4.687 0 00.721-2.215 4.834 4.834 0 00-.2-1.668 3.891 3.891 0 00-7.383 0 4.791 4.791 0 00-.2 1.671 4.9 4.9 0 001.21 2.887.335.335 0 01-.09.506l-1.399.807A4.718 4.718 0 00-.007 13.61v1H6.27a6.549 6.549 0 01-.158-1.114zm15.549-3.974l-1.4-.808a.329.329 0 01-.162-.231.334.334 0 01.072-.273 4.908 4.908 0 001.212-2.889 4.836 4.836 0 00-.2-1.668 3.891 3.891 0 00-5.967-1.929A3.89 3.89 0 0013.8 3.654a4.793 4.793 0 00-.2 1.671c.05.787.3 1.549.723 2.214.015.007.032.011.048.018.75.33 1.423.813 1.977 1.418.12.13.227.268.331.4a2.302 2.302 0 00-.334-2.451 2.752 2.752 0 01-.655-2.63 1.846 1.846 0 011.028-1.136 1.91 1.91 0 012.18.458 1.9 1.9 0 01.388.677 2.762 2.762 0 01-.656 2.633 2.337 2.337 0 00.624 3.519l1.4.808c.53.308.938.789 1.155 1.362h-3.942c.023.294.028.59.014.885a6.536 6.536 0 01-.165 1.115h6.277v-1a4.723 4.723 0 00-2.332-4.092zm-5.499 8.056l-1.4-.808a.331.331 0 01-.156-.376.331.331 0 01.067-.128 4.912 4.912 0 001.211-2.89 4.837 4.837 0 00-.2-1.668 3.891 3.891 0 00-7.382 0 4.792 4.792 0 00-.2 1.671 4.901 4.901 0 001.21 2.887.334.334 0 01-.09.506l-1.4.808a4.718 4.718 0 00-2.333 4.088v1h12.997v-1a4.72 4.72 0 00-2.324-4.09zm-8.48 3.088a2.665 2.665 0 011.15-1.356l1.399-.808a2.334 2.334 0 00.625-3.52 2.753 2.753 0 01-.655-2.63 1.858 1.858 0 011.028-1.136 1.933 1.933 0 011.54 0 1.847 1.847 0 011.028 1.135c.079.296.11.602.094.908a2.884 2.884 0 01-.75 1.725 2.335 2.335 0 00.624 3.518l1.4.808c.526.308.93.786 1.147 1.356h-8.63z'
      />
    </svg>
  ),
  'group-by': (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'>
      <line x1='21' y1='5' x2='2' y2='5' />
      <line x1='21' y1='10' x2='7' y2='10' />
      <line x1='21' y1='15' x2='7' y2='15' />
    </svg>
  ),
  'help-outline': (
    <svg viewBox='0 0 24 24' width='24' height='24' fill='none'>
      <path
        fill='currentColor'
        d='M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z'
      />
      <path
        fill='currentColor'
        d='M12.162 8a1.72 1.72 0 0 0-1.643 2.235l-1.909.597a3.72 3.72 0 1 1 7.273-1.111c0 .763-.22 1.435-.714 2.107-.423.577-.987.92-1.385 1.162l-.164.101c-.277.174-.398.31-.47.444-.076.143-.15.388-.15.87V15h-2v-.596c0-.675.102-1.279.386-1.812.29-.541.713-.907 1.17-1.194l.212-.133c.412-.256.614-.382.788-.62.255-.347.327-.608.327-.925 0-.95-.77-1.72-1.72-1.72h-.001ZM11 19v-2h2v2h-2Z'
      />
    </svg>
  ),
  help: (
    <svg height='24' width='24' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm9.441-2.28a1.72 1.72 0 1 1 3.442 0c0 .317-.072.578-.327.926-.174.237-.376.363-.788.619l-.213.133c-.456.287-.88.653-1.169 1.194-.284.533-.387 1.137-.387 1.812V15h2v-.595c0-.481.075-.726.151-.87.072-.133.193-.27.47-.443l.164-.1c.398-.243.962-.586 1.385-1.163.494-.672.714-1.344.714-2.108a3.72 3.72 0 1 0-7.273 1.112l1.91-.597a1.72 1.72 0 0 1-.079-.515V9.72ZM11 17v2h2v-2h-2Z'
      />
    </svg>
  ),
  'hide-sidebar': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.891 6.939A.939.939 0 0 0 12.952 6H2.94a.939.939 0 0 0 0 1.878h10.013c.519 0 .939-.42.939-.94Zm0 5.32a.939.939 0 0 0-.939-.94H2.94a.939.939 0 0 0 0 1.878h10.013c.519 0 .939-.42.939-.938Zm0 5.32a.939.939 0 0 0-.939-.94H2.94a.939.939 0 1 0 0 1.878h10.013c.519 0 .939-.42.939-.939ZM16.857 8.059a.939.939 0 0 0 0 1.327l2.877 2.877-2.877 2.876a.939.939 0 0 0 1.328 1.328l3.54-3.54a.939.939 0 0 0 0-1.328l-3.54-3.54a.939.939 0 0 0-1.328 0Z'
        fill='currentColor'
      />
    </svg>
  ),
  'home-outline': (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M12.5 3.247a1 1 0 0 0-1 0L4 7.577V20h4.5v-6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6H20V7.577l-7.5-4.33Zm-2-1.732a3 3 0 0 1 3 0l7.5 4.33a2 2 0 0 1 1 1.732V21a1 1 0 0 1-1 1h-6.5a1 1 0 0 1-1-1v-6h-3v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.577a2 2 0 0 1 1-1.732l7.5-4.33Z'
      />
    </svg>
  ),
  home: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M13.5 1.515a3 3 0 0 0-3 0L3 5.845a2 2 0 0 0-1 1.732V21a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6h4v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7.577a2 2 0 0 0-1-1.732l-7.5-4.33Z'
      />
    </svg>
  ),
  industries: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M176 416v64M80 32h192a32 32 0 0 1 32 32v412a4 4 0 0 1-4 4H48h0V64a32 32 0 0 1 32-32zm240 160h112a32 32 0 0 1 32 32v256h0-160 0V208a16 16 0 0 1 16-16z'
      />
      <path d='M98.08 431.87a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm80 240a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm80 320a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zm0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79z' />
      <ellipse
        cx='256'
        cy='176'
        rx='15.95'
        ry='16.03'
        transform='rotate(-45 255.99 175.996)'
      />
      <path d='M258.08 111.87a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79zM400 400a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64 160a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16z' />
    </svg>
  ),
  'info-small': (
    <svg viewBox='0 0 16 16' fill='none'>
      <path
        d='M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z'
        fill='currentColor'
      />
    </svg>
  ),
  info: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      height='24'
      width='24'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        d='M250.26 166.05 256 288l5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 6z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        d='M256 367.91a20 20 0 1 1 20-20 20 20 0 0 1-20 20z'
        fill='currentColor'
      />
    </svg>
  ),
  'info-alt': (
    <svg
      height='24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'>
      <path fill='currentColor' d='M11 6v2h2V6h-2zm0 4v8h2v-8h-2z' />
      <path
        fill='currentColor'
        d='M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12z'
      />
    </svg>
  ),
  kazoo: (
    <svg viewBox='0 0 500 500' xmlSpace='preserve'>
      <path
        fill='currentColor'
        d='M203.31 123.2c-2.79 0-5.46-1.58-6.72-4.27l-29.2-62.14c-1.74-3.71-.15-8.13 3.56-9.87 3.71-1.74 8.13-.15 9.87 3.56l29.2 62.14c1.74 3.71.15 8.13-3.56 9.87-1.02.49-2.09.71-3.15.71zm-32.29 27.4c-1.7 0-3.41-.58-4.8-1.77l-38.48-32.71c-3.12-2.65-3.5-7.34-.85-10.46s7.34-3.5 10.46-.85l38.48 32.71c3.12 2.65 3.5 7.34.85 10.46a7.394 7.394 0 0 1-5.66 2.62zm68.03-35.7h-.25c-4.1-.14-7.31-3.57-7.17-7.66l1.67-50.47c.14-4.1 3.58-7.33 7.66-7.17 4.1.14 7.31 3.57 7.17 7.66l-1.67 50.47c-.13 4.01-3.43 7.17-7.41 7.17zm237.08-37c-12.84-11.21-34.16-17-50.78-3.33l-117.67 83.61c-3.8-3.76-8.41-7.05-13.76-9.78-13.81-7.08-31.08-9.59-48.61-7.09-17.52 2.51-33.39 9.77-44.68 20.43-11.82 11.18-17.36 24.79-15.61 38.36v39.39c0 1.86.16 3.71.47 5.53L29.27 356.03c-9.18 4.5-16.1 13.26-17.79 24.12l-1.45 9.32c-1.56 9.99.86 19.99 6.83 28.15 5.96 8.17 14.74 13.52 24.74 15.07L171 452.87c1.68.26 3.36.38 5.01.38 8.77 0 16.95-3.56 22.9-9.5 1.18-1.02 1.42-1.42 2.11-2.21l283.65-325.41c.26-.28.48-.6.68-.91 7.11-11.31 3.41-26.31-9.22-37.32zm-228.72 78.11c3.75-.54 7.48-.81 11.13-.81 10.48 0 20.38 2.19 28.63 6.41 3.08 1.57 5.81 3.37 8.15 5.36 1.99 1.7 3.7 3.52 5.12 5.46.92 1.26 1.72 2.56 2.38 3.9a23.734 23.734 0 0 1 2.24 7.17v.01c.36 2.49.31 5.01-.14 7.51-1.14 6.44-4.86 12.83-10.89 18.52l-.43.4-16.58-11.77-3.7-2.63-2.71-1.92-6.07-4.31h-.01l-.32-.24-8.46-6.01-29.42-20.88c6.39-2.99 13.53-5.1 21.08-6.17zm57.9 73.17c.04 6.47-2.43 12.55-6.96 17.11-7.56 7.62-20.8 17.05-40.92 18.64-24.02 1.89-40-4.42-49.18-10.04a17.09 17.09 0 0 1-4.8-4.44c-1.5-2.02-2.57-4.38-3.13-6.88-.3-1.32-.46-2.69-.46-4.08v-13.11c1.79 1.52 3.73 2.95 5.82 4.28a58.98 58.98 0 0 0 5.23 3.02c.65.33 1.31.65 1.97.97 2.64 1.23 5.4 2.32 8.26 3.23 7.83 2.53 16.39 3.83 25.22 3.83 4.34 0 8.75-.32 13.18-.95 17.52-2.5 33.39-9.76 44.68-20.43.34-.33.68-.65 1.02-.98l.07 9.83zm-105.38-38.13c1.13-6.43 4.86-12.82 10.89-18.52.64-.6 1.3-1.19 1.98-1.76l21.62 15.35 8.78 6.23 8.2 5.83.58.42h.01l5.82 4.13 6.4 4.55 16.36 11.61c-6.9 3.52-14.76 5.98-23.14 7.18-6.86.98-13.62 1.05-20.03.26-3.44-.43-6.77-1.1-9.96-2.03-2.92-.84-5.73-1.89-8.38-3.14-.46-.22-.93-.46-1.39-.69-7.38-3.79-12.75-8.88-15.64-14.73a24.156 24.156 0 0 1-2.25-7.16v-.01c-.35-2.49-.3-5.01.15-7.52zm-4.45 225.97-1.05 6.67c-.31 2.03-.94 3.93-1.84 5.65-.94 1.84-2.18 3.49-3.64 4.89-.04.06-.09.1-.14.15a18.722 18.722 0 0 1-15.69 4.88l-129.4-20.17c-6.36-.99-11.94-4.4-15.74-9.59-3.8-5.2-5.34-11.55-4.35-17.91l1.46-9.32c.47-3.08 1.68-5.87 3.43-8.21a18.62 18.62 0 0 1 4.82-4.55c1.89-1.23 4-2.12 6.25-2.61 2.18-.48 4.48-.57 6.82-.2l126.74 19.75c7.07 1.1 13.28 4.89 17.5 10.66 4.21 5.77 5.92 12.85 4.83 19.91zM473.04 106.9 209.47 409.95c-.53-7.5-3.16-14.73-7.71-20.96-6.37-8.75-15.79-14.48-26.49-16.14L57.13 354.43l134.23-95.39c2.44 3.38 5.53 6.29 9.13 8.5 9.73 5.96 25.65 12.57 48.4 12.57 3.11 0 6.35-.12 9.71-.39 24.65-1.95 40.95-13.57 50.29-22.98 7.33-7.39 11.33-17.21 11.26-27.66l-.26-37.74v-.01l-.06-8.93c0-.22-.01-.45-.04-.68-.01-.1-.03-.21-.04-.31l-.03-.19c-.56-3.85-1.69-7.53-3.35-11.01l117.8-83.71c.15-.12.32-.23.46-.36 9.97-8.33 23.44-4.31 31.75 2.93 5.6 4.9 9.74 12.24 6.66 17.83z'
      />
    </svg>
  ),
  lightblub: (
    <svg viewBox='0 0 24 24'>
      <path d='M9 22h6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm-1.5-3a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1zm8.043-8.472a5 5 0 1 0-7.085 0C9.242 11.317 10 12.512 10 14h4c0-1.488.757-2.683 1.543-3.472zm1.417 1.412c-.555.557-.96 1.274-.96 2.06v2H8v-2c0-.786-.405-1.503-.96-2.06a7 7 0 1 1 9.92 0z' />
    </svg>
  ),
  locate: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        d='M12 2C8.135 2 5 4.984 5 8.66c0 4.229 4.667 10.93 6.38 13.246a.766.766 0 0 0 1.24 0C14.333 19.592 19 12.892 19 8.66 19 4.984 15.865 2 12 2Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 11.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  magnify: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='currentColor'
        d='M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z'
      />
    </svg>
  ),
  'mail-open': (
    <svg viewBox='0 0 512 512'>
      <path
        d='M448.67 154.45 274.1 68.2a41.1 41.1 0 0 0-36.2 0L63.33 154.45A55.6 55.6 0 0 0 32 204.53v184.61c0 30.88 25.42 56 56.67 56h334.66c31.25 0 56.67-25.12 56.67-56V204.53a55.6 55.6 0 0 0-31.33-50.08zM252.38 96.82a8.22 8.22 0 0 1 7.24 0L429 180.48l-172 85a8.22 8.22 0 0 1-7.24 0L80.35 181.81z'
        fill='currentColor'
      />
    </svg>
  ),
  'mail-outline': (
    <svg viewBox='0 0 512 512'>
      <rect
        x='48'
        y='96'
        width='416'
        height='320'
        rx='40'
        ry='40'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='40'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='40'
        d='M112 160l144 112 144-112'
      />
    </svg>
  ),
  'manage-outline': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill='currentColor'
        d='m22.402 11.264-1.512-.562a.858.858 0 0 1-.483-.65.817.817 0 0 1 .167-.748l1.114-1.16a.929.929 0 0 0 .16-1.064 11.215 11.215 0 0 0-2.864-3.59.929.929 0 0 0-1.072-.08l-1.253.756a.912.912 0 0 1-.865-.018.938.938 0 0 1-.548-.663l-.191-1.461a.929.929 0 0 0-.731-.788 11.284 11.284 0 0 0-4.593 0 .929.929 0 0 0-.729.788l-.186 1.415a.979.979 0 0 1-.575.694.951.951 0 0 1-.9.018l-1.224-.738a.929.929 0 0 0-1.07.08 11.254 11.254 0 0 0-2.865 3.591.929.929 0 0 0 .162 1.062l1.09 1.131a.845.845 0 0 1 .17.769.881.881 0 0 1-.495.663l-1.502.557a.928.928 0 0 0-.607.887c.03 1.547.377 3.072 1.022 4.479a.929.929 0 0 0 .928.536l1.798-.17a.772.772 0 0 1 .607.304.738.738 0 0 1 .175.674l-.558 1.693a.929.929 0 0 0 .316 1.027 11.206 11.206 0 0 0 4.137 1.989.929.929 0 0 0 1-.392l1.056-1.613a.753.753 0 0 1 1.077.02l1.044 1.592a.93.93 0 0 0 1 .392 11.203 11.203 0 0 0 4.137-1.992.929.929 0 0 0 .316-1.027l-.569-1.727a.716.716 0 0 1 .167-.65.725.725 0 0 1 .59-.294l1.806.17a.923.923 0 0 0 .93-.537 11.268 11.268 0 0 0 1.02-4.478.93.93 0 0 0-.597-.885Zm-1.486 2.764c-.096.416-.22.825-.372 1.224l-1.126-.106a2.648 2.648 0 0 0-2.694 3.377l.356 1.078a9.371 9.371 0 0 1-2.297 1.106l-.668-1.022a2.5 2.5 0 0 0-2.113-1.096 2.449 2.449 0 0 0-2.073 1.078l-.683 1.04a9.394 9.394 0 0 1-2.295-1.105l.344-1.045a2.674 2.674 0 0 0-2.721-3.408l-1.115.105a9.371 9.371 0 0 1-.57-2.484l.864-.32A2.816 2.816 0 0 0 4.77 7.992l-.618-.64A9.434 9.434 0 0 1 5.74 5.359l.64.385a2.786 2.786 0 0 0 2.67.061 2.806 2.806 0 0 0 1.602-2.12l.098-.743a9.449 9.449 0 0 1 2.55 0l.101.784a2.878 2.878 0 0 0 4.219 2.028l.67-.404a9.49 9.49 0 0 1 1.59 1.993l-.645.67a2.791 2.791 0 0 0 1.006 4.427l.875.325a9.69 9.69 0 0 1-.2 1.263ZM12 7.213a4.644 4.644 0 1 0 .007 0H12Zm0 7.43a2.786 2.786 0 1 1 .007 0H12Z'
      />
    </svg>
  ),
  manage: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='m20.89 10.702 1.512.562a.93.93 0 0 1 .598.885 11.266 11.266 0 0 1-1.022 4.478.923.923 0 0 1-.929.537l-1.806-.17a.722.722 0 0 0-.59.294.716.716 0 0 0-.167.65l.57 1.727a.928.928 0 0 1-.317 1.027 11.203 11.203 0 0 1-4.137 1.992.93.93 0 0 1-1-.392L12.558 20.7a.75.75 0 0 0-1.077-.02l-1.055 1.612a.93.93 0 0 1-1 .392 11.206 11.206 0 0 1-4.138-1.988.929.929 0 0 1-.316-1.027l.558-1.693a.737.737 0 0 0-.175-.674.77.77 0 0 0-.607-.303l-1.798.17a.93.93 0 0 1-.928-.537A11.268 11.268 0 0 1 1 12.153a.928.928 0 0 1 .607-.887l1.502-.557a.882.882 0 0 0 .494-.663.845.845 0 0 0-.169-.769l-1.09-1.131a.929.929 0 0 1-.162-1.062 11.254 11.254 0 0 1 2.866-3.591.929.929 0 0 1 1.07-.08l1.223.738a.951.951 0 0 0 .9-.018.979.979 0 0 0 .575-.694l.186-1.415a.929.929 0 0 1 .73-.788 11.284 11.284 0 0 1 4.592 0 .93.93 0 0 1 .73.788l.192 1.461a.937.937 0 0 0 .548.663.912.912 0 0 0 .864.018l1.254-.756a.929.929 0 0 1 1.072.08 11.215 11.215 0 0 1 2.864 3.59.93.93 0 0 1-.16 1.063l-1.114 1.161a.817.817 0 0 0-.167.748.858.858 0 0 0 .483.65ZM10.08 9.056a3.715 3.715 0 0 1 2.065-.626h.005a3.72 3.72 0 0 1 3.71 3.715 3.714 3.714 0 1 1-5.78-3.09Z'
        clipRule='evenodd'
      />
    </svg>
  ),
  'measure-outline': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path fill='currentColor' d='M1 1h2.069v19.931H23V23H1V1Z' />
      <path
        fill='currentColor'
        d='M16.172 4.31a1.034 1.034 0 0 1 1.035-1.034h5.724V9a1.035 1.035 0 0 1-2.069 0V6.807l-4.047 4.047a3.793 3.793 0 0 1-2.681 1.112H10.9c-.457 0-.895.181-1.218.504l-4.338 4.338v-2.927l2.874-2.874a3.793 3.793 0 0 1 2.682-1.11h3.233a1.73 1.73 0 0 0 1.22-.505l4.045-4.047h-2.192a1.034 1.034 0 0 1-1.035-1.035Z'
      />
    </svg>
  ),
  measure: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M2.375 1A1.375 1.375 0 0 0 1 2.375v19.25A1.375 1.375 0 0 0 2.375 23h19.25A1.375 1.375 0 0 0 23 21.625V2.375A1.375 1.375 0 0 0 21.625 1H2.375Zm3.438 2.75v10.238l3.01-3.011a3.782 3.782 0 0 1 2.675-1.108h1.847a1.72 1.72 0 0 0 1.215-.503l2.178-2.178H14.75a1.031 1.031 0 0 1 0-2.063h5.5v5.5a1.031 1.031 0 1 1-2.063 0v-1.97l-2.168 2.168a3.782 3.782 0 0 1-2.674 1.108h-1.847c-.455 0-.894.182-1.215.504l-4.47 4.47v1.282H20.25v2.063H3.75V3.75h2.063Z'
      />
    </svg>
  ),
  minus: (
    <svg width='24' height='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M400 256H112'
      />
    </svg>
  ),
  more: (
    <svg width='24' height='24' viewBox='0 0 512 512'>
      <path
        fill='currentColor'
        d='M296 136c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40z'
      />
    </svg>
  ),
  music: (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M6 3h15v15.167a3.5 3.5 0 11-3.5-3.5H19V5H8v13.167a3.5 3.5 0 11-3.5-3.5H6V3zm0 13.667H4.5a1.5 1.5 0 101.5 1.5v-1.5zm13 0h-1.5a1.5 1.5 0 101.5 1.5v-1.5z'
      />
    </svg>
  ),
  nielsen: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M9.723 8.425A8.423 8.423 0 0111.1 7.263c.422-.27.947-.407 1.581-.407.998 0 1.708.343 2.131 1.028.423.685.634 1.59.634 2.71v7.307a.563.563 0 01-.457.591 6.34 6.34 0 01-1.238.19V19h5.869v-.263c-.174-.017-.36-.042-.563-.071a4.777 4.777 0 01-.562-.115 1.4 1.4 0 01-.448-.215.42.42 0 01-.186-.343V9.465c0-1.314-.3-2.384-.893-3.213-.593-.828-1.45-1.243-2.562-1.243-.514 0-1.023.103-1.497.304-.469.196-.91.452-1.315.761-.397.302-.76.646-1.082 1.028-.286.335-.55.688-.79 1.057M9.004 8.958v8.99c.02.158.09.305.203.418a.888.888 0 00.342.19c.15.041.303.066.457.072.185.011.369.035.55.072v.287H5v-.283a3.695 3.695 0 001.142-.262c.312-.135.464-.35.464-.668V7.816a1.142 1.142 0 00-.042-.342.677.677 0 00-.245-.263l-.605-.334a7.252 7.252 0 00-.685-.333v-.182L8.796 5h.195l.013 3.958z'
        fill='CURRENTCOLOR'
      />
    </svg>
  ),
  notifications: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill='currentColor'
        d='M11.566 2.913a5.26 5.26 0 0 0-5.261 5.26v5.624L4.31 17.26h14.512l-1.995-3.466V8.174a5.26 5.26 0 0 0-5.261-5.261Zm-7.174 5.26a7.174 7.174 0 0 1 14.348 0v5.11l3.391 5.89H14.88a3.348 3.348 0 1 1-6.628 0H1l3.392-5.888V8.174Zm5.82 11a1.435 1.435 0 1 0 2.707 0h-2.707Z'
      />
    </svg>
  ),
  order: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M96 256h320M96 176h320M96 336h320'
      />
    </svg>
  ),
  overlap: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M.85 11.887a7.008 7.008 0 0 0 7.037 7.037 7.008 7.008 0 0 0 7.037-7.037A7.008 7.008 0 0 0 7.887 4.85 7.008 7.008 0 0 0 .85 11.887Zm1.257 0c0-3.17 2.61-5.78 5.78-5.78 3.263 0 5.78 2.609 5.78 5.78 0 3.17-2.61 5.78-5.78 5.78-3.17 0-5.78-2.61-5.78-5.78Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='.3'
      />
      <path
        d='M9.076 11.887a7.008 7.008 0 0 0 7.037 7.037 7.008 7.008 0 0 0 7.037-7.037 7.008 7.008 0 0 0-7.037-7.037 7.008 7.008 0 0 0-7.037 7.037Zm1.257 0c0-3.17 2.61-5.78 5.78-5.78 3.17 0 5.78 2.61 5.78 5.78 0 3.17-2.61 5.78-5.78 5.78-3.17 0-5.78-2.61-5.78-5.78Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='.3'
      />
    </svg>
  ),
  pause: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M176 96h16v320h-16zm144 0h16v320h-16z'
      />
    </svg>
  ),
  pencil: (
    <svg width='20' height='20' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M20.41 4.94l-1.35-1.35c-.78-.78-2.05-.78-2.83 0L3 16.82V21h4.18L20.41 7.77c.79-.78.79-2.05 0-2.83zm-14 14.12L5 19v-1.36l9.82-9.82 1.41 1.41-9.82 9.83z'
      />
    </svg>
  ),
  play: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        fill='currentColor'
        d='M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z'
      />
    </svg>
  ),
  plus: (
    <svg height='24' width='24' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2Z'
      />
    </svg>
  ),
  'podcast-outline': (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M12 3a9 9 0 0 0-7.046 14.6L3.42 18.886A10.954 10.954 0 0 1 1 12C1 5.925 5.925 1 12 1s11 4.925 11 11a10.96 10.96 0 0 1-2.421 6.886L19.046 17.6A9 9 0 0 0 12 3Z'
      />
      <path
        fill='currentColor'
        d='M12 7a4 4 0 0 0-4 4v3a4.002 4.002 0 0 0 3 3.874v1.965l-2.715 2.278a.5.5 0 0 0 .322.883h6.786a.5.5 0 0 0 .322-.883L13 19.839v-1.965c1.725-.444 3-2.01 3-3.874v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-4 0v-3a2 2 0 0 1 4 0v3Z'
      />
    </svg>
  ),
  podcast: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M3.42 18.886A10.954 10.954 0 0 1 1 12C.999 5.925 5.923 1 11.999 1c6.074 0 11 4.925 11 11 0 2.606-.907 5.001-2.422 6.886l-2.3-1.93a8 8 0 1 0-12.56 0l-2.297 1.93Z'
      />
      <path
        fill='currentColor'
        d='M11.999 7a4 4 0 0 0-4 4v3a4.002 4.002 0 0 0 3 3.874v1.965l-2.715 2.278a.5.5 0 0 0 .322.883h6.786a.5.5 0 0 0 .322-.883l-2.715-2.278v-1.965c1.725-.444 3-2.01 3-3.874v-3a4 4 0 0 0-4-4Z'
      />
    </svg>
  ),
  radio: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <circle fill='currentColor' cx='256' cy='256' r='36' />
      <path
        fill='currentColor'
        d='M190.24 341.77a22 22 0 0 1-16.46-7.38 118 118 0 0 1 0-156.76 22 22 0 1 1 32.87 29.24 74 74 0 0 0 0 98.29 22 22 0 0 1-16.43 36.61zm131.52 0a22 22 0 0 1-16.43-36.61 74 74 0 0 0 0-98.29 22 22 0 1 1 32.87-29.24 118 118 0 0 1 0 156.76 22 22 0 0 1-16.44 7.38z'
      />
      <path
        fill='currentColor'
        d='M139.29 392.72a21.92 21.92 0 0 1-16.08-7 190 190 0 0 1 0-259.49 22 22 0 1 1 32.13 30.06 146 146 0 0 0 0 199.38 22 22 0 0 1-16.06 37zm233.42 0a22 22 0 0 1-16.06-37 146 146 0 0 0 0-199.38 22 22 0 1 1 32.13-30.06 190 190 0 0 1 0 259.49 21.92 21.92 0 0 1-16.07 6.95z'
      />
      <path
        fill='currentColor'
        d='M429 438a22 22 0 0 1-16.39-36.67 218.34 218.34 0 0 0 0-290.66 22 22 0 0 1 32.78-29.34 262.34 262.34 0 0 1 0 349.34A22 22 0 0 1 429 438zm-346 0a21.94 21.94 0 0 1-16.41-7.33 262.34 262.34 0 0 1 0-349.34 22 22 0 0 1 32.78 29.34 218.34 218.34 0 0 0 0 290.66A22 22 0 0 1 83 438z'
      />
    </svg>
  ),
  ray: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M315.27 33 96 304h128l-31.51 173.23a2.36 2.36 0 0 0 2.33 2.77h0a2.36 2.36 0 0 0 1.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 0 0-2.44-2.75h0a2.42 2.42 0 0 0-1.95 1z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
    </svg>
  ),
  'remove-circle-outline': (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M336 256H176'
      />
    </svg>
  ),
  'reports-outline': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill='currentColor'
        d='M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z'
      />
      <path
        fill='currentColor'
        d='M12 6.05a1 1 0 0 1 1 1v7.486l1.793-1.793a1 1 0 1 1 1.414 1.414L12 18.364l-4.207-4.207a1 1 0 1 1 1.414-1.414L11 14.536V7.05a1 1 0 0 1 1-1Z'
      />
    </svg>
  ),
  reports: (
    <svg height='24' width='24' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm12-4.95a1 1 0 0 0-2 0v7.486l-1.793-1.793a1 1 0 0 0-1.414 1.414L12 18.364l4.207-4.207a1 1 0 0 0-1.414-1.415L13 14.535V7.05Z'
      />
    </svg>
  ),
  research: (
    <svg fill='none' viewBox='0 0 24 24' height='24' width='24'>
      <path
        d='M15.82 14.314H15l-.308-.257c.975-1.183 1.59-2.674 1.59-4.371A6.663 6.663 0 009.616 3C5.974 3 3 5.983 3 9.686a6.663 6.663 0 006.667 6.685c1.64 0 3.18-.617 4.359-1.594l.307.258v.822L19.462 21 21 19.457l-5.18-5.143zm-6.153 0A4.603 4.603 0 015.05 9.686a4.603 4.603 0 014.616-4.629 4.603 4.603 0 014.615 4.629 4.603 4.603 0 01-4.615 4.628z'
        fill='currentColor'
      />
    </svg>
  ),
  send: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z'
        fill='currentColor'
      />
    </svg>
  ),
  sort: (
    <svg fill='none' height='20' width='20' viewBox='0 0 20 20'>
      <path
        d='M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.59l-1.3-1.3a1 1 0 00-1.4 1.42l3 3a1 1 0 001.4 0l3-3a1 1 0 00-1.4-1.42L15 13.6V8z'
        fill='currentColor'
      />
    </svg>
  ),
  spotify: (
    <svg
      width='24'
      height='24'
      viewBox='0 0 1333.33 1333.3'
      shapeRendering='geometricPrecision'
      textRendering='geometricPrecision'
      imageRendering='optimizeQuality'
      fillRule='evenodd'
      clipRule='evenodd'>
      <path
        d='M666.66 0C298.48 0 0 298.47 0 666.65c0 368.19 298.48 666.65 666.66 666.65 368.22 0 666.67-298.45 666.67-666.65C1333.33 298.49 1034.88.03 666.65.03l.01-.04zm305.73 961.51c-11.94 19.58-37.57 25.8-57.16 13.77-156.52-95.61-353.57-117.26-585.63-64.24-22.36 5.09-44.65-8.92-49.75-31.29-5.12-22.37 8.84-44.66 31.26-49.75 253.95-58.02 471.78-33.04 647.51 74.35 19.59 12.02 25.8 37.57 13.77 57.16zm81.6-181.52c-15.05 24.45-47.05 32.17-71.49 17.13-179.2-110.15-452.35-142.05-664.31-77.7-27.49 8.3-56.52-7.19-64.86-34.63-8.28-27.49 7.22-56.46 34.66-64.82 242.11-73.46 543.1-37.88 748.89 88.58 24.44 15.05 32.16 47.05 17.12 71.46V780zm7.01-189.02c-214.87-127.62-569.36-139.35-774.5-77.09-32.94 9.99-67.78-8.6-77.76-41.55-9.98-32.96 8.6-67.77 41.56-77.78 235.49-71.49 626.96-57.68 874.34 89.18 29.69 17.59 39.41 55.85 21.81 85.44-17.52 29.63-55.89 39.4-85.42 21.8h-.03z'
        fill='currentColor'
        fillRule='nonzero'
      />
    </svg>
  ),
  spotifyAdvertising: (
    <svg
      width='265'
      height='40'
      viewBox='0 0 265 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M142.832 21.808h7.858l-3.929-9.585-3.929 9.585zm8.476 1.508h-9.094l-2.334 5.704h-1.821l7.695-18.422h2.04l7.7 18.422h-1.825l-2.361-5.704zM162.171 27.832c2.922 0 4.781-2.458 4.781-5.66 0-3.203-1.859-5.628-4.751-5.628-2.948 0-4.901 2.345-4.901 5.628 0 3.202 1.885 5.66 4.867 5.66m4.782-1.516a5.098 5.098 0 0 1-1.98 2.262 5.337 5.337 0 0 1-2.949.794c-3.951 0-6.489-3.14-6.489-7.2 0-4.017 2.594-7.169 6.489-7.169 3.017 0 4.397 1.771 4.902 2.922v-8.26h1.769v16.731c-.012.868.038 1.736.15 2.597h-1.723a14.19 14.19 0 0 1-.147-2.14l-.022-.537zM177.76 29.001h-1.859l-5.577-13.628h2.006l4.483 11.685 4.544-11.685h1.979l-5.576 13.628zM194.744 21.088c-.06-2.556-1.742-4.542-4.691-4.542-2.639 0-4.524 2.03-4.69 4.542h9.381zm1.768 4.057a6.078 6.078 0 0 1-2.347 3.122 6.408 6.408 0 0 1-3.818 1.118c-3.717 0-6.843-2.655-6.843-7.227 0-4.287 3.016-7.143 6.519-7.143 4.148 0 6.55 2.856 6.58 6.884.005.21-.005.42-.03.628h-11.271v.117c.031 3.14 2.263 5.2 5.045 5.2 2.538 0 4.012-1.428 4.601-3.228l1.564.53zM206.004 17.145a5.134 5.134 0 0 0-1.237-.143c-2.39 0-4.147 1.486-4.147 4.601v7.417h-1.772V15.374h1.742v2.556a4.363 4.363 0 0 1 1.723-2.025 4.588 4.588 0 0 1 2.613-.692c.369-.012.737.038 1.09.146l-.012 1.786zM212.032 15.374h3.658v1.545h-3.658v8.227c0 1.658.796 2.457 2.387 2.457.435.002.866-.076 1.271-.23v1.516c-.559.192-1.15.28-1.742.259-2.263 0-3.688-1.344-3.688-3.83v-8.4h-2.979v-1.544h1.064c1.383 0 1.975-.599 1.975-1.997V11.06h1.712v4.313zM217.272 15.374h1.768V29.02h-1.768V15.374zm.882-6.255c.293-.001.579.082.822.24.244.156.434.38.547.64.112.262.142.55.085.828a1.417 1.417 0 0 1-.403.734c-.207.2-.47.337-.757.393a1.525 1.525 0 0 1-.855-.081 1.473 1.473 0 0 1-.664-.527 1.404 1.404 0 0 1-.249-.796 1.358 1.358 0 0 1 .104-.552c.072-.175.181-.334.318-.468a1.489 1.489 0 0 1 1.052-.412zM222.649 24.89c.268 1.657 1.565 2.997 3.865 2.997 1.742 0 3.13-1 3.13-2.428 0-1.256-.886-1.942-2.391-2.286l-2.262-.515c-2.063-.456-3.45-1.654-3.45-3.626 0-2.19 2.183-4.017 4.751-4.017 3.273 0 4.66 1.888 5.045 3.517l-1.565.57c-.264-1.315-1.241-2.6-3.48-2.6-1.595 0-3.017.971-3.017 2.399 0 1.172.754 1.858 2.21 2.173l2.262.485c2.33.515 3.658 1.8 3.658 3.772 0 1.972-1.769 4.017-4.902 4.017-3.45 0-5.192-2.143-5.456-3.944l1.602-.514zM233.628 15.373h1.768V29.02h-1.768V15.374zm.886-6.255c.292 0 .578.084.821.242.243.157.432.38.544.642.112.261.141.55.084.827a1.422 1.422 0 0 1-.404.733c-.207.2-.47.336-.757.392a1.522 1.522 0 0 1-.854-.082 1.466 1.466 0 0 1-.663-.527 1.395 1.395 0 0 1-.249-.795 1.388 1.388 0 0 1 .422-1.022 1.482 1.482 0 0 1 1.056-.41zM240.225 29.02h-1.768V15.372h1.712v2.191c.754-1.46 2.417-2.516 4.574-2.516 3.303 0 4.984 2.286 4.984 5.087v8.884h-1.772v-8.617c0-2.14-1.09-3.827-3.804-3.827-2.417 0-3.926 1.972-3.926 4.287v8.157zM262.593 21.662c0-2.943-1.829-5.112-4.604-5.112-2.775 0-4.721 2.143-4.721 5.112 0 2.969 1.886 5.141 4.721 5.141 2.775 0 4.604-2.19 4.604-5.141zm-9.427 7.712a4.274 4.274 0 0 0 1.469 2.818 4.542 4.542 0 0 0 3.056 1.097c3.718 0 4.838-2.429 4.838-5.259v-2.512c-.619 1.399-2.183 2.772-4.751 2.772-3.688 0-6.282-2.83-6.282-6.628 0-3.714 2.538-6.602 6.282-6.602 2.639 0 4.072 1.256 4.781 2.658v-2.344h1.742v12.63c0 3.17-1.448 6.8-6.64 6.8-3.424 0-5.81-2.173-6.165-5.028l1.67-.402zM33.029 17.557C26.44 13.77 15.57 13.42 9.274 15.267a1.97 1.97 0 0 1-1.484-.11 1.904 1.904 0 0 1-.592-.46 1.833 1.833 0 0 1-.36-.648 1.796 1.796 0 0 1 .156-1.434c.124-.216.292-.407.493-.56.201-.152.432-.265.679-.33 7.22-2.121 19.23-1.712 26.808 2.648.436.25.752.659.877 1.135s.05.98-.21 1.403c-.258.422-.68.727-1.171.848a1.966 1.966 0 0 1-1.449-.202m-.207 5.62c-.221.349-.576.598-.986.694a1.64 1.64 0 0 1-1.205-.183c-5.494-3.286-13.872-4.217-20.361-2.308a1.645 1.645 0 0 1-1.24-.088 1.587 1.587 0 0 1-.496-.384 1.498 1.498 0 0 1-.17-1.739 1.56 1.56 0 0 1 .41-.468c.17-.128.362-.221.568-.275 7.425-2.19 16.655-1.125 22.963 2.63.36.214.617.557.715.955.098.398.03.817-.19 1.166m-2.5 5.393c-.178.28-.462.479-.79.555a1.314 1.314 0 0 1-.964-.146c-4.8-2.84-10.84-3.483-17.955-1.91a1.314 1.314 0 0 1-.998-.124 1.26 1.26 0 0 1-.38-.334 1.216 1.216 0 0 1-.225-.95c.031-.164.096-.321.192-.46.095-.14.22-.26.364-.351a1.3 1.3 0 0 1 .477-.183c7.787-1.724 14.468-.983 19.856 2.19.288.172.494.447.573.765.08.319.025.654-.15.934M20.947 0a20.92 20.92 0 0 0-11.36 3.335c-3.362 2.176-5.983 5.268-7.531 8.886A19.22 19.22 0 0 0 .893 23.66c.788 3.84 2.736 7.37 5.595 10.138 2.86 2.77 6.502 4.655 10.468 5.419 3.967.764 8.078.371 11.813-1.128 3.736-1.499 6.929-4.037 9.175-7.293a19.357 19.357 0 0 0 3.444-11.002c0-5.25-2.154-10.285-5.987-13.997C31.568 2.086 26.37 0 20.948 0zM56.115 18.295c-3.529-.814-4.147-1.388-4.147-2.589 0-1.136 1.104-1.899 2.745-1.899 1.64 0 3.17.577 4.826 1.775a.221.221 0 0 0 .173.04.227.227 0 0 0 .151-.091l1.727-2.352a.225.225 0 0 0-.045-.306 10.638 10.638 0 0 0-6.787-2.272c-3.812 0-6.47 2.213-6.47 5.383 0 3.396 2.296 4.6 6.263 5.528 3.393.756 3.947 1.384 3.947 2.512 0 1.253-1.154 2.03-3.016 2.03-2.059 0-3.74-.671-5.618-2.249a.233.233 0 0 0-.328.026L47.6 26.058a.218.218 0 0 0 .023.31 11.734 11.734 0 0 0 7.779 2.89c4.11 0 6.76-2.192 6.76-5.537 0-2.84-1.753-4.414-6.033-5.426M74.438 22.103c0 2.4-1.527 4.075-3.714 4.075-2.187 0-3.789-1.749-3.789-4.075s1.629-4.075 3.79-4.075c2.16 0 3.713 1.712 3.713 4.075zm-2.982-7.18a5.683 5.683 0 0 0-2.472.53 5.5 5.5 0 0 0-1.97 1.541v-1.566a.223.223 0 0 0-.068-.16.238.238 0 0 0-.166-.067h-3.16a.235.235 0 0 0-.163.067.22.22 0 0 0-.066.16v17.4c0 .059.024.116.067.157a.234.234 0 0 0 .163.066h3.16c.06 0 .12-.024.163-.065a.223.223 0 0 0 .07-.158V27.35a5.641 5.641 0 0 0 1.993 1.46 5.815 5.815 0 0 0 2.449.487c3.307 0 6.655-2.465 6.655-7.18 0-4.714-3.348-7.179-6.655-7.179M86.692 26.205c-2.263 0-3.97-1.764-3.97-4.101 0-2.337 1.647-4.05 3.917-4.05 2.27 0 4 1.764 4 4.101 0 2.337-1.659 4.05-3.947 4.05zm0-11.28a7.665 7.665 0 0 0-2.9.51 7.478 7.478 0 0 0-2.467 1.559 7.21 7.21 0 0 0-1.651 2.363 7.02 7.02 0 0 0-.576 2.798c0 4.017 3.314 7.154 7.54 7.154 4.228 0 7.625-3.166 7.625-7.205s-3.307-7.18-7.571-7.18zM103.354 15.202h-3.477v-3.444a.222.222 0 0 0-.068-.156.237.237 0 0 0-.162-.066h-3.16a.238.238 0 0 0-.163.065.223.223 0 0 0-.07.157v3.444h-1.508a.237.237 0 0 0-.164.066.222.222 0 0 0-.066.16v2.63c0 .059.024.115.067.157a.234.234 0 0 0 .163.065h1.508v6.807c0 2.753 1.414 4.145 4.2 4.145a5.92 5.92 0 0 0 2.96-.713.213.213 0 0 0 .117-.194v-2.504a.22.22 0 0 0-.22-.219c-.04 0-.078.01-.112.029a4.108 4.108 0 0 1-1.855.434c-1.014 0-1.467-.445-1.467-1.46v-6.328h3.477a.232.232 0 0 0 .162-.066.216.216 0 0 0 .068-.157v-2.63a.222.222 0 0 0-.141-.21.237.237 0 0 0-.089-.016M115.466 15.216v-.438c0-1.241.493-1.796 1.598-1.796.614.01 1.221.123 1.795.336a.242.242 0 0 0 .211-.033.215.215 0 0 0 .094-.183v-2.578a.21.21 0 0 0-.044-.134.227.227 0 0 0-.118-.082 9 9 0 0 0-2.639-.365c-2.919 0-4.461 1.593-4.461 4.601v.65h-1.508a.236.236 0 0 0-.163.066.22.22 0 0 0-.067.157v2.648a.222.222 0 0 0 .141.21.239.239 0 0 0 .089.016h1.508v10.495a.222.222 0 0 0 .141.21.243.243 0 0 0 .089.016h3.16a.235.235 0 0 0 .164-.066.214.214 0 0 0 .066-.16V18.284h2.96l4.525 10.495c-.513 1.095-1.018 1.321-1.708 1.321a3.726 3.726 0 0 1-1.742-.478.239.239 0 0 0-.184-.018.228.228 0 0 0-.137.12L118.165 32a.22.22 0 0 0 .098.292 6.85 6.85 0 0 0 3.394.837c2.334 0 3.623-1.052 4.762-3.886l5.456-13.734a.219.219 0 0 0-.026-.208.229.229 0 0 0-.189-.098h-3.292a.245.245 0 0 0-.133.042.226.226 0 0 0-.085.107l-3.367 9.323-3.696-9.326a.213.213 0 0 0-.083-.107.229.229 0 0 0-.131-.04l-5.407.015zM108.448 15.201h-3.167a.237.237 0 0 0-.163.068.223.223 0 0 0-.067.159v13.35c0 .06.024.117.067.16a.237.237 0 0 0 .163.067h3.163a.237.237 0 0 0 .163-.068.223.223 0 0 0 .067-.159v-13.35a.223.223 0 0 0-.067-.159.237.237 0 0 0-.163-.068M106.887 9.122c-.447 0-.885.129-1.257.37-.372.24-.662.582-.833.982-.171.4-.216.841-.129 1.266.088.425.303.816.62 1.122.316.307.719.515 1.158.6a2.33 2.33 0 0 0 1.307-.125 2.246 2.246 0 0 0 1.015-.807 2.14 2.14 0 0 0 .382-1.217c0-.581-.239-1.138-.663-1.55a2.3 2.3 0 0 0-1.6-.641zM132.122 26.036h-.577v.73h.577c.291 0 .464-.135.464-.365 0-.23-.173-.365-.464-.365zm.377 1.019.63.85h-.532l-.565-.78h-.487v.8h-.444v-2.261h1.04c.543 0 .898.27.898.73a.668.668 0 0 1-.142.438.7.7 0 0 1-.398.249m-.494-2.162a2.049 2.049 0 0 0-.771.146 1.989 1.989 0 0 0-.653.424 1.887 1.887 0 0 0-.578 1.384 1.863 1.863 0 0 0 .574 1.374c.186.18.407.323.65.42.243.096.504.144.767.14a2.04 2.04 0 0 0 1.365-.598c.358-.362.558-.844.558-1.346 0-.501-.2-.983-.558-1.346a2.04 2.04 0 0 0-1.365-.598m0 4.104a2.276 2.276 0 0 1-.852-.16 2.226 2.226 0 0 1-.723-.466 2.13 2.13 0 0 1-.482-.7 2.075 2.075 0 0 1-.167-.825c0-.574.235-1.125.654-1.53a2.291 2.291 0 0 1 2.434-.47c.271.108.516.267.723.467.207.2.371.439.483.7a2.099 2.099 0 0 1-.483 2.352c-.207.2-.452.36-.723.468a2.29 2.29 0 0 1-.853.164'
        fill='#000'
      />
    </svg>
  ),
  sync: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        d='M11.625 20c-2.233 0-4.133-.775-5.7-2.325-1.567-1.55-2.35-3.442-2.35-5.675v-.175l-.9.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7l2.6-2.6c.1-.1.208-.171.325-.213.117-.041.242-.062.375-.062s.258.02.375.062a.883.883 0 0 1 .325.213l2.6 2.6a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275l-.9-.9V12c0 1.667.588 3.083 1.763 4.25C8.513 17.417 9.942 18 11.625 18a5.402 5.402 0 0 0 1.925-.35.974.974 0 0 1 .538-.05.887.887 0 0 1 .487.25c.3.3.421.62.363.962-.059.342-.28.58-.663.713-.433.15-.87.267-1.312.35a7.209 7.209 0 0 1-1.338.125Zm6.95-4.45a1.1 1.1 0 0 1-.375-.063.871.871 0 0 1-.325-.212l-2.6-2.6a.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275l.9.9V12c0-1.667-.587-3.083-1.762-4.25C14.638 6.583 13.208 6 11.525 6c-.333 0-.658.03-.975.088a5.733 5.733 0 0 0-.95.262.97.97 0 0 1-.537.05.887.887 0 0 1-.488-.25c-.3-.3-.421-.621-.363-.963.059-.341.28-.579.663-.712.433-.15.871-.267 1.313-.35A7.19 7.19 0 0 1 11.525 4c2.233 0 4.133.775 5.7 2.325 1.567 1.55 2.35 3.442 2.35 5.675v.175l.9-.9a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7l-2.6 2.6c-.1.1-.208.17-.325.212a1.1 1.1 0 0 1-.375.063Z'
        fill='currentColor'
      />
    </svg>
  ),
  'tag-outline': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <circle cx='17.725' cy='6.275' r='1.225' fill='currentColor' />
      <path
        d='M21 4.023C21 3.458 20.542 3 19.977 3h-6.085c-.544 0-1.065-.028-1.367.274l-9.298 9.298a.773.773 0 0 0 0 1.094l7.107 7.108a.774.774 0 0 0 1.094 0l9.298-9.299c.302-.301.273-.81.273-1.366L21 4.023Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    </svg>
  ),
  tag: (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 3H3c-.829 0-1.5.666-1.5 1.5v6l10.036 10.036c.588.587 1.539.59 2.123.005l5.382-5.382a1.502 1.502 0 00-.005-2.123L9 3zM5.625 8.25a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z'
        fill='currentColor'
      />
    </svg>
  ),
  tune: (
    <svg viewBox='0 0 24 24' width='24' height='24' fill='none'>
      <path
        fill='currentColor'
        d='M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM2 18a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM13.528 2H6a4 4 0 1 0 0 8h7.528a5.997 5.997 0 0 1-1.187-2H6a2 2 0 1 1 0-4h6.341a5.997 5.997 0 0 1 1.187-2Zm-1.87 18a5.997 5.997 0 0 1-1.186 2H18a4 4 0 0 0 0-8h-7.528a5.997 5.997 0 0 1 1.187 2H18a2 2 0 1 1 0 4h-6.341Z'
      />
    </svg>
  ),
  'unread-notifications': (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill='currentColor'
        d='M16.828 10.088v3.71l1.996 3.465H4.31l1.995-3.465V8.175a5.261 5.261 0 0 1 4.962-5.252 5.716 5.716 0 0 1 .882-1.9 7.175 7.175 0 0 0-7.757 7.152v5.112L1 19.177h7.253a3.348 3.348 0 1 0 6.628 0h7.252l-3.392-5.891V9.76a5.727 5.727 0 0 1-1.913.328Zm-6.696 9.566c0-.168.028-.328.081-.478h2.707a1.437 1.437 0 0 1-1.11 1.89 1.435 1.435 0 0 1-1.678-1.412Z'
      />
      <path
        fill='currentColor'
        className='dot'
        d='M13.958 4.349a2.87 2.87 0 1 0 5.74 0 2.87 2.87 0 0 0-5.74 0Z'
      />
    </svg>
  ),
  user: (
    <svg height='24' width='24' viewBox='0 0 512 512'>
      <path
        d='M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        d='M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z'
        fill='none'
        stroke='currentColor'
        strokeMiterlimit='10'
        strokeWidth='32'
      />
    </svg>
  ),
  verified: (
    <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.937 2.503a1.373 1.373 0 0 1 2.126 0l.908 1.11a.458.458 0 0 0 .516.138l1.341-.507c.811-.306 1.7.207 1.84 1.063l.233 1.415a.458.458 0 0 0 .377.377l1.415.232c.856.14 1.37 1.03 1.063 1.841l-.507 1.341a.458.458 0 0 0 .138.516l1.11.908c.67.55.67 1.576 0 2.126l-1.11.908a.458.458 0 0 0-.138.516l.507 1.341c.306.812-.207 1.7-1.063 1.84l-1.415.233a.458.458 0 0 0-.377.377l-.232 1.415a1.373 1.373 0 0 1-1.841 1.063l-1.341-.507a.458.458 0 0 0-.516.138l-.908 1.11a1.373 1.373 0 0 1-2.126 0l-.908-1.11a.458.458 0 0 0-.516-.138l-1.341.507a1.373 1.373 0 0 1-1.84-1.063l-.233-1.415a.458.458 0 0 0-.377-.377l-1.415-.232a1.374 1.374 0 0 1-1.063-1.841l.507-1.341a.458.458 0 0 0-.138-.516l-1.11-.908a1.373 1.373 0 0 1 0-2.126l1.11-.908a.458.458 0 0 0 .138-.516l-.507-1.341a1.373 1.373 0 0 1 1.063-1.84l1.415-.233a.458.458 0 0 0 .377-.377l.232-1.415a1.373 1.373 0 0 1 1.841-1.063l1.341.507c.184.07.392.014.516-.138l.908-1.11Zm1.417.58a.458.458 0 0 0-.708 0l-.908 1.11a1.373 1.373 0 0 1-1.548.414l-1.342-.506a.458.458 0 0 0-.613.354L7.003 5.87A1.373 1.373 0 0 1 5.87 7.003l-1.415.232a.458.458 0 0 0-.354.613l.506 1.342a1.373 1.373 0 0 1-.414 1.548l-1.11.908a.458.458 0 0 0 0 .708l1.11.908c.456.374.623.997.414 1.548l-.506 1.342a.458.458 0 0 0 .354.613l1.415.232a1.373 1.373 0 0 1 1.133 1.133l.232 1.415a.458.458 0 0 0 .613.354l1.342-.507a1.373 1.373 0 0 1 1.548.415l.908 1.11a.458.458 0 0 0 .708 0l.908-1.11a1.373 1.373 0 0 1 1.548-.415l1.341.507a.458.458 0 0 0 .614-.354l.232-1.415a1.373 1.373 0 0 1 1.133-1.133l1.415-.232a.458.458 0 0 0 .354-.613l-.507-1.342a1.374 1.374 0 0 1 .415-1.548l1.11-.908a.458.458 0 0 0 0-.708l-1.11-.908a1.374 1.374 0 0 1-.415-1.548l.507-1.342a.458.458 0 0 0-.354-.613l-1.415-.232a1.373 1.373 0 0 1-1.133-1.133l-.232-1.415a.458.458 0 0 0-.614-.354l-1.34.506a1.373 1.373 0 0 1-1.549-.414l-.908-1.11Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='.5'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m17.36 9.119-6.41 6.41a.458.458 0 0 1-.647 0l-3.662-3.663.647-.647 3.339 3.338 6.086-6.085.647.647Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='.5'
      />
    </svg>
  ),
  windows: (
    <svg viewBox='0 0 88 88'>
      <path d='m0 12.402 35.687-4.8602.0156 34.423-35.67.20313zm35.67 33.529.0277 34.453-35.67-4.9041-.002-29.78zm4.3261-39.025 47.318-6.906v41.527l-47.318.37565zm47.329 39.349-.0111 41.34-47.318-6.6784-.0663-34.739z' />
    </svg>
  ),
} as const;
